import React from 'react';
import PropTypes from 'prop-types';

const SvgIcon = props => {
    const { children, className, ...rest } = props;

    return (
        <svg
            className={className}
            focusable="false"
            viewBox="0 0 32 32 "
            aria-hidden="true"
            role="presentation"
            width="1em"
            height="1em"
            fontSize="24px"
            fill="currentColor"
            {...rest}
        >
            {children}
        </svg>
    );
};

SvgIcon.propTypes = {
    iconData: PropTypes.string,
    children: PropTypes.any,
    className: PropTypes.string
};

export default SvgIcon;
